var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-share-map-select-user-dialog',{attrs:{"show":_vm.showDialogShareMapSelectUser},on:{"cerrar":function($event){_vm.showDialogShareMapSelectUser = false}}}),_c('vx-share-map-received-request-dialog'),_c('vx-share-map-users-connected-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }